import { colorize, formatHighlight } from '../colorScheme'
import { automatticCreed, taxjarWay } from '../../content/valuesData'

export function buildCreedBlock(): string {
  const lines = automatticCreed
    .map((line) => `  ${colorize('|', 'cyan')} ${line}`)
    .join('\n')

  return `
${formatHighlight('THE AUTOMATTIC CREED')}
${colorize('automattic.com/creed', 'brightBlack')}

${lines}
`
}

export function buildTaxJarBlock(): string {
  const lines = taxjarWay
    .map((line) => `  ${colorize('▸', 'yellow')} ${line}`)
    .join('\n')

  return `
${formatHighlight('THE TAXJAR WAY')}
${colorize("Value cards from Anderson's office board", 'brightBlack')}

${lines}
`
}
